module.exports = __webpack_public_path__ + "img/frame_contenuti.9971f1ee.png";